export default "__VITE_ASSET__C06EadKU__"